import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import type { ContextMenuItemProps } from './ContextMenuSubmenuItem.tsx';
import { ContextMenuSubmenuItem } from './ContextMenuSubmenuItem.tsx';

const ContextMenuItem = ({ options, handleClick }: ContextMenuItemProps) => {
  return options.map((item, index) => {
    if (item.type === 'divider') {
      return <Divider key={`divider-${index}`} />;
    }

    if (item.type === 'submenu') {
      return <ContextMenuSubmenuItem key={`submenu-${index}`} item={item} handleClick={handleClick} />;
    }

    return (
      <MenuItem
        sx={{ minWidth: item.actionIcon ? '266px' : '170px' }}
        key={`item-${index}`}
        onClick={(e) => handleClick(e, item.callback)}
        disabled={item.disabled}
      >
        <Box display="flex" alignItems="center" justifyContent={item.actionIcon ? 'flex-start' : 'space-between'} width="100%">
          {item.actionIcon && (
            <Box component="div" display="flex" marginRight={'12px'} alignItems="center" justifyContent="center">
              {item.actionIcon}
            </Box>
          )}
          {item.title}
          {item.icon && (
            <Box component="div" marginLeft={item.actionIcon ? 'auto' : 0} display="flex" alignItems="center" justifyContent="center">
              {item.icon}
            </Box>
          )}
        </Box>
      </MenuItem>
    );
  });
};

export default ContextMenuItem;
